module.exports = __webpack_public_path__ + "img/klaviyo.179c8de0.png";